interface MessageLaunchTarget {
    pathname: string;
    messageActionToken?: string;
}

/** Navigation only: launch data never grants a spin or authorizes a game answer. */
export function parseMessageLaunch(token: unknown): MessageLaunchTarget | null {
    if (token === "inbox") return { pathname: "/inbox" };
    if (typeof token !== "string") return null;
    if (/^mg1_[A-Za-z0-9_-]{1,508}$/.test(token)) {
        return { pathname: "/inbox", messageActionToken: token };
    }
    if (!/^wheel1_[A-Za-z0-9_-]{2,128}$/.test(token)) return null;
    try {
        const wheelCode = atob(
            token.slice(7).replace(/-/g, "+").replace(/_/g, "/"),
        );
        if (!/^[a-zA-Z0-9][a-zA-Z0-9_.:-]{0,95}$/.test(wheelCode)) return null;
        return { pathname: `/wheels/${encodeURIComponent(wheelCode)}` };
    } catch {
        return null;
    }
}
